import { message } from 'antd';
import styled from 'styled-components';

export default styled(message)`
	// Add your styles here
`;
